import { Injectable } from '@angular/core';
import { HttpResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map'
import {ClientRequest} from  '../../ClientRequest';


@Injectable()
export class ProfileService {
  constructor(private clientRequest: ClientRequest) {}
 
  myCourse(): Observable<any> {
    return this.clientRequest.get('/profile/mycourse').map((response: HttpResponse<any>) => {
      return response;
    });
  };
  getNotifications(): Observable<any> {
    return this.clientRequest.get('/profile/notifications').map((response: HttpResponse<any>) => {
       return response;
    });
  };
  getProfile(): Observable<any> {
    return this.clientRequest.get( '/profile/myprofile').map((response: HttpResponse<any>) =>{return response});
  };
  loadPackages(enroll_parent_id): Observable<any> {
    return this.clientRequest.get( '/profile/packages/'+enroll_parent_id).map((response: HttpResponse<any>) =>{ return response});
  };
  loadReports(enroll_id): Observable<any> {
    return  this.clientRequest.get( '/profile/report/'+enroll_id).map((response: HttpResponse<any>) => { return response});
  };
  
  updateProfile(data): Observable<any> {
    return  this.clientRequest.post( '/profile/myprofile', data).map((response: HttpResponse<any>) => {
              return response;
            });
  };
  updatePassword(oldpassword: string, password: string, repeatpassword: string): Observable<any> {
    var data = JSON.stringify({ oldpassword: oldpassword, password: password, repeatpassword: repeatpassword});
    return  this.clientRequest.post( '/profile/updatePassword',data)
            .map((response: HttpResponse<any>) => {
              return response;
            });
  }
}
